/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Geofence Filled Icon component.
 */
export const SystemGeofenceFilledIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12.4421 4L4 12.5951V18.5887L18.3252 4H12.4421Z' fill={iconColor} />
      <path d='M10.1806 4H5.02866C4.75583 4 4.49419 4.10838 4.30127 4.3013C4.10835 4.49421 4 4.75589 4 5.02871V10.2912L10.1806 4Z' fill={iconColor} />
      <path d='M20.0002 10.5975V5.02895C19.9998 4.90675 19.9768 4.78566 19.9322 4.67188L4.90137 19.9747C4.94374 19.9796 4.98649 19.9796 5.02886 19.9747H10.7589L20.0002 10.5975Z' fill={iconColor} />
      <path d='M13.0288 20.0002H18.9799C19.2505 20.0002 19.51 19.8927 19.7013 19.7014C19.8926 19.5101 20.0001 19.2506 20.0001 18.98V12.9014L13.0288 20.0002Z' fill={iconColor} />
    </svg>
  );
};

export default SystemGeofenceFilledIcon;
